/* eslint-disable */ 
import React from 'react'
import CustomModal from '../../../views/components/Modal/CustomModal'
import WarningIcon from 'static/images/Warning.png'
import ContentHeader from '../../containers/ContentHeader/ContentHeaderNew'
import {
  SETTINGS_REDESIGN_HEADER_HEIGHT,
  BOTTOM_PADDING,
  getEmailFrequencyOptions,
  getEmailFrequencyOptionDisplayText,
  EMAIL_FREQUENCY_TYPES,
} from '../../constants'
import EcgLoader from '../../containers/EcgLoader'
import styles from './TeamMemberFile.css'
import { getName } from '../../containers/Utilities'
import { EditMemberForm } from '../../containers/Forms'
import { needToBustCache } from '../../store/appReducer'
import { checkReferralsOnlyFeatureEnabled, checkTKFeatureEnabled, checkCRPFeatureEnabled, checkRpmFeatureEnabled } from 'configs'
import Toast from '../../../views/components/Modal/SnackBar';
import history from '../../containers/History'
import { getYearMonthDateFormat, addDays } from 'common/dateUtils'
class TeamMemberFile extends React.Component {
  state = {
    innerHeight: 0,
    innerWidth: 0,
    isReactivateModalOpen:false,
  }

  UNSAFE_componentWillMount() {
    const {
      match,
      dataLastUpdated,
      setInitialTeamMemberData,
      getTeamMemberFileData,
      getAppointmentNotificationsSettings,
    } = this.props
    setInitialTeamMemberData(match)
    getTeamMemberFileData(needToBustCache(dataLastUpdated))
    getAppointmentNotificationsSettings()

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }
 handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    // dispatch(showToastHandler(false));
  }
  handleModalOpen=()=>{
    this.setState({isReactivateModalOpen:true})
  }
  handleConfirmReactivate=()=>{
    this.props.handleOnReactivateAccountClick({isDeactivated: false})
    this.setState({isReactivateModalOpen:false})
  }
  handleModalClose=()=>{
    this.setState({isReactivateModalOpen:false})
  }


  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      getTeamMemberFileData,
      handleOnEditTeamMemberSubmit,
      handleOnTeamMemberDeleteClick,

      selectedTeamMemberId,
      physicians,
      editMemberFormData,
      me,
      notification,
      handleAppointmentNotificationsChange,
      setAccountActivate,
      setAccountDeactivate,
      isAccountDeactivate,
      handleOnReactivateAccountClick,
      handleOnDeactivateAccountClick,
    } = this.props

    const {
      innerHeight,
      innerWidth,
    } = this.state

    const height = innerHeight - SETTINGS_REDESIGN_HEADER_HEIGHT - BOTTOM_PADDING 
    const width = 1180 - (20 * 2)

    const cleanValues = value => {
      const newReminders = {
        emailFrequency: {
          label: getEmailFrequencyOptionDisplayText(value.reminders.emailFrequency),
          id: value.reminders.emailFrequency,
        },
        personalReminder: value.reminders.personalReminder,
        triageReminder: value.reminders.triageReminder,
        personalEsignReportReminder: value.reminders.personalEsignReportReminder,
        teamEsignReportReminder: value.reminders.teamEsignReportReminder,
        teamExportReportReminder: value.reminders.teamExportReportReminder,
      }

      const newProfile = {
        ...value,
        reminders: newReminders,
      }
      return newProfile
    }

    let physician
    let initialValues
    let details
    if (physicians.data && physicians.data.byId[selectedTeamMemberId] && physicians.data.byId[selectedTeamMemberId].reminders && !dataIsFetching) {
      physician = physicians.data.byId[selectedTeamMemberId]
      initialValues = cleanValues(physician)
      details={
        firstname:initialValues.firstName,
        lastName:initialValues.lastName,
        is_deactivated:initialValues.is_deactivated,
        deactivated_at:initialValues.deactivated_at ? getYearMonthDateFormat(addDays(initialValues.deactivated_at)):'',
      }
      
    }

    const myId = me.data && me.data.profile.id

    const tkEnabled = checkTKFeatureEnabled(me)
    const crpEnabled = checkCRPFeatureEnabled(me)
    const rpmEnabled = checkRpmFeatureEnabled(me)
    const referralsOnlyFeatureEnabled = checkReferralsOnlyFeatureEnabled(me)
   
    return (
      <React.Fragment>
      <div data-page="team-member-file" className={styles.teamMemberFile}>
        <ContentHeader
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={() => getTeamMemberFileData(true)}
          text={physician && getName(physician.firstName, physician.lastName, '')}
          enableBackButton={true}
          showAddPatient={false}
          me={me}
          backButtonIconShow={false}
          backButtonText={'Back'}
        />
        {(details&&details.is_deactivated) && (!this.state.isReactivateModalOpen) && (
            <div style={{ height: "72px",
            position: "relative",
            marginTop:'-2rem'
            }}>
              <Toast
                open={true}
                closeHandler={() => this.handleClose()}
                message1="This member’s account has been deactivated."
                message2={`Their information will be permanently deleted in ${details&&details.deactivated_at}`}
                severity="error"
                button={false}
                setAccountActivate={setAccountActivate}
                handleOnReactivateAccountClick={handleOnReactivateAccountClick}
                selectedTeamMemberId={selectedTeamMemberId}
                handleModalOpen={this.handleModalOpen}
                
              />
            </div>
          )}
         { (details&&details.is_deactivated) && (!this.state.isReactivateModalOpen) && (
            <div style={{ height: "72px",
            position: "relative",
            marginTop: "2rem",
            marginBottom:'2rem'}}>
              <Toast
                open={true}
                closeHandler={() => this.handleClose()}
                alertMessage={`Search Results are not available at the moment!`}
                message1="Would you like to reactivate this member?"
                message2="They will be able to provide the selected services again."
                severity="success"
                button={true}
                setAccountActivate={setAccountActivate}
                handleOnReactivateAccountClick={handleOnReactivateAccountClick}
                selectedTeamMemberId={selectedTeamMemberId}
                handleModalOpen={this.handleModalOpen}
              />
            </div>
          )}

        <div
          className={styles.formWrapper}
          style={{
            height,
          }}
        >
          {!dataIsFetching
            ? ( <div className={styles.formTop}>
                <EditMemberForm
                  onSubmit={handleOnEditTeamMemberSubmit}
                  initialValues={initialValues}
                  isSubmitting={dataIsFetching}
                  handleOnTeamMemberDeleteClick={handleOnTeamMemberDeleteClick}
                  editMemberFormData={editMemberFormData}
                  isMe={myId === selectedTeamMemberId}
                  showEmailReminder={!referralsOnlyFeatureEnabled}
                  showTKFeatureEnabled={tkEnabled}
                  showCRPFeatureEnabled={crpEnabled}
                  showRPMFeatureEnabled={rpmEnabled}
                  isAdminEnabled = {me && me.data && me.data.profile.permissions.isAdmin}
                  notification={notification}
                  handleAppointmentNotificationsChange={handleAppointmentNotificationsChange}
                  setAccountActivate={setAccountActivate}
                  setAccountDeactivate={setAccountDeactivate}
                  isAccountDeactivate={isAccountDeactivate}
                  setAccountActivate={setAccountActivate}
                handleOnReactivateAccountClick={handleOnReactivateAccountClick}
                selectedTeamMemberId={selectedTeamMemberId}
                handleOnDeactivateAccountClick={handleOnDeactivateAccountClick}
                
                />
              </div>
            )
            : (
              <EcgLoader />
            )
          }
        </div>
      </div>
      <CustomModal
          modalType="confirm"
          open={this.state.isReactivateModalOpen}
          closeModalHandler={() => { this.handleModalClose() }}
          icon={WarningIcon}
          iconAltText="Warning Icon"
          heading={`Are you sure you want to reactivate ${details && details.firstname}${details && details.lastName}`}
          descriptionLine1="This will enable this user to provide the selected services again. "
          descriptionLine2=""
          confirmHandler={e => this.handleConfirmReactivate()}
          confirmButtonText="Yes, Reactivate"
          declineButtonText="CANCEL"
        />
      </React.Fragment>
    )
  }
}

export default TeamMemberFile



// WEBPACK FOOTER //
// ./src/legacy/pages/TeamMemberFile/TeamMemberFile.jsx